module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.hiddenElement()
  }, [(_vm.groupType == 'field' && _vm.name != 'company') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "placeholder": _vm.placeholder,
      "label": _vm.label,
      "fromLeadMask": true,
      "enrich_tags": _vm.element.enrich_tags
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'field' && _vm.name == 'company') ? _c('auto-complete', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    staticClass: "autofill",
    class: _vm.elem_class,
    attrs: {
      "model": "project_lead",
      "name": _vm.name,
      "item": _vm.item,
      "label": _vm.label,
      "fromLeadMask": true,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.items,
      "init": _vm.item[_vm.name],
      "placeholder": _vm.placeholder
    },
    on: {
      "populate-fields": _vm.populateFields,
      "change": _vm.updateName
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'readonly') ? _c('field', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "readonly": true,
      "name": _vm.name,
      "id": _vm.name,
      "type": "text",
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "placeholder": _vm.placeholder,
      "label": _vm.label,
      "fromLeadMask": true
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'quantity_selection') ? _c('quantity-selection', {
    directives: [{
      name: "can",
      rawName: "v-can",
      value: ('project_leads.update'),
      expression: "'project_leads.update'"
    }],
    class: _vm.elem_class,
    attrs: {
      "errors": _vm.errors,
      "model": "project_lead",
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.elem_type,
      "required": _vm.element.required,
      "params": _vm.element.params,
      "collection": _vm.element.allowed_values,
      "defaultValue": _vm.element.default_value,
      "label": _vm.label
    },
    on: {
      "change": _vm.change,
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'country_select') ? _c('country-select', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "params": _vm.element.params,
      "id": _vm.name,
      "model": "project_lead",
      "label": _vm.label,
      "fromLeadMask": true,
      "required": _vm.required,
      "language": _vm.language
    },
    on: {
      "change": function($event) {
        return _vm.bus(_vm.data)
      },
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'tag_list') ? _c('tag-list', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "model": "project_lead",
      "id": _vm.name,
      "required": _vm.required,
      "label": _vm.label,
      "fromLeadMask": true
    },
    on: {
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'free_drawing') ? _c('free-drawing', {
    attrs: {
      "errors": _vm.errors,
      "name": _vm.name,
      "id": _vm.name,
      "model": "project_lead",
      "required": _vm.required,
      "label": _vm.label
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }) : (_vm.groupType == 'crawled_info') ? _c('crawled-infos', {
    class: _vm.elem_class,
    attrs: {
      "type": _vm.elem_type,
      "params": _vm.element.params,
      "item": _vm.item
    }
  }) : (_vm.groupType == 'date') ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('datepicker', {
    class: _vm.elem_class,
    attrs: {
      "item": _vm.item,
      "name": _vm.name,
      "id": _vm.name,
      "required": _vm.required,
      "errors": _vm.errors,
      "label": _vm.label,
      "clear-button": true,
      "language": _vm.getDatePickerLanguage()
    },
    on: {
      "populate-fields": _vm.populateFields
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  })], 1) : (_vm.groupType == 'title') ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.element.content))])]) : (_vm.groupType == 'paragraph') ? _c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.element.content)
    }
  })]) : (_vm.groupType == 'container') ? _c('div', {
    staticClass: "element",
    class: _vm.elem_class
  }, _vm._l((_vm.element.children), function(element) {
    return _c('lead-mask-element', {
      key: element.name,
      attrs: {
        "type": element.element_type,
        "element": element,
        "name": element.name,
        "label": element.label,
        "errors": _vm.errors,
        "language": _vm.language,
        "item": _vm.item
      },
      on: {
        "populate-fields": _vm.populateFields
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8ef3e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadMaskElement.vue
// module id = 1830
// module chunks = 0